import Chip from '@mui/material/Chip';
import type { ChipProps } from '@mui/material';
import { ComponentType, ElementType } from 'react';

export interface TagProps extends ChipProps {
  component?: ComponentType | ElementType;
  href?: string | URL;
}
export const Tag = (props: TagProps) => <Chip {...props} />;
